import * as React from "react";
import "./App.css";
import Navbar from "./components/Navbar";

import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter } from "react-router-dom";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import { Grid, Container, Typography } from "@mui/material";
import BottomBar from "./components/BottomBar";
import Cart from "./components/Cart";
import Account from "./pages/Account.js";
import Property from "./pages/Property.js";
import Payment from "./pages/Payment.js";
import Review from "./pages/Review";
import Error from "./pages/Error";
import ThankYou from "./pages/ThankYou";

import Bolt from "./assets/bolt.png";
import BlankCart from "./assets/blank-cart-placeholder.png";
import House from "./assets/house.png";

import planConfig from "./plan-configuration.json";
import { Auth } from "aws-amplify";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";

let theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#FF127F",
    },
    secondary: {
      main: "#81F1C5",
      contrastText: "#8496A6",
    },
    tertiary: {
      main: "#672490",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#092C4C",
    },
  },
  typography: {
    fontFamily: "Montserrat",
    h1: {
      fontWeight: 700,
      fontSize: "4.6rem",
      color: "#092C4C",
    },
    h2: {
      fontWeight: 700,
      fontSize: "3.1rem",
      color: "#092C4C",
    },
    h3: {
      fontWeight: 600,
      color: "#092C4C",
    },
    h4: {
      fontWeight: 600,
      color: "#092C4C",
    },
    h5: {
      fontSize: "1.1em",
      color: "#092C4C",
      fontWeight: 700,
    },
    h6: {
      fontSize: "0.8em",
      color: "#092C4C",
      fontWeight: 400,
    },
    subtitle1: {
      fontWeight: 600,
      color: "#8496A6",
    },
    fontWeightBold: 700,
    body: {
      fontSize: 15,
      color: "#092C4C",
    },
    bodySubtle: {
      fontSize: 15,
      color: "#808080",
    },
  },
});

theme = responsiveFontSizes(theme);

const steps = [
  "Your Details",
  "Connection Details",
  "Payment Details",
  "Review & Complete",
];

function App() {
  const mediaQuery = useMediaQuery("(max-width:900px)");

  const [cafState, setCafState] = React.useState({
    contact1_title: "",
    contact1_first_name: "",
    contact1_last_name: "",
    contact1_mobile_no: "",
    contact1_phone_std: "",
    contact1_phone_no: "",
    email_address: "",
    contact1_email_address: "",
    site_floor_no: "",
    site_floor_type: "",
    site_unit_no: "",
    site_unit_type: "",
    site_network_code: "",
    previous_supplier_code: "",
    conc_end_date: "",
    conc_group_home_flag: "",
    conc_start_date: "",
    conc_first_name: "",
    conc_last_name: "",
    conc_ls_start_date: "",
    contact1_date_of_birth: "",
    contact1_drivers_licence: "",
    contact1_drivers_expiry: "",
    contact1_passport: "",
    contact1_passport_expiry: "",
    contact1_medicard_no: "",
    payment_method_type: "DIRECT",
    direct_debit_bank_code: "",
    direct_debit_number: "",
    credit_card_no: "",
    credit_card_expiry_date: "",
    credit_card_verif_no: "",
    credit_card_type_code: "",
    smoothpay_amount: "",
    User_Defined_3: "",
    green_percent: "",
    user_defined_4: "",
    user_defined_2: "",
    promo_allowed: "",
    bill_cycle_code: "",
    brand_code: "",
    product_type_code: "",
    conc_consent_flag: "",
    contract_term_code: "",
    invoice_delivery_class: "",
    letter_delivery_class: "",
    company_type: "",
    industry_type_code: "",
    credit_card_name: "",
    conc_ms_flag: "",
    conc_ls_end_date: "",
    business_phone_no: "",
    contracted_capacity_code: "",
    life_support_on_site: "",
    connectionsCaf: [],
  });

  const [activeStep, setActiveStep] = React.useState(0);

  const stepperState = {
    activeStep,
    setActiveStep,
    steps,
  };

  const [cart, setCart] = React.useState([]);

  const [user, setUser] = React.useState({
    user: null,
    identity: {
      title: "",
      dob: null,
      idType: "",
      idNumber: "",
      expiryDate: null,
    },
  });

  const [connections, setConnections] = React.useState([]);

  const [signupFinished, setSignupFinished] = React.useState(false);

  const [payment, setPayment] = React.useState({
    paymentDetails: [
      {
        bsb: "",
        accountNumber: "",
      },
    ],
    useSamePaymentMethod: true,
  });

  const [termsAndConditions, setTermsAndConditions] = React.useState(false);

  const login = React.useCallback(async () => {
    try {
      let newUser = await Auth.currentAuthenticatedUser();
      let attributes = await Auth.userAttributes(newUser);
      setUser((user) => {
        const newUser = { ...user, user: attributes };
        return newUser;
      });
      setCafState((cafState) => {
        const newCafState = {
          ...cafState,
          contact1_title: attributes[0].Value,
          contact1_first_name: attributes[5].Value,
          contact1_last_name: attributes[6].Value,
          contact1_mobile_no: attributes[4].Value,
          contact1_email_address: attributes[7].Value,
          email_address: attributes[7].Value,
        };
        return newCafState;
      });
      setActiveStep(1);
    } catch (error) {
      console.log("No current authenitcated user");
    }
  }, []);

  const handleUpdateConnections = () => {
    let newCart = [];
    connections.forEach((e) => {
      if (e.confirmed) {
        // console.log(e);
        newCart.push({
          planName: e.planName,
          planDescriptor: e.planDescriptor,
          planPrice: "10% below reference price",
          planConditionsLink: planConfig[e.planName].planConditionsLink,
          planBasicInformationLink:
            planConfig[e.planName].planBasicInformationLink,
          bpidLinks: planConfig[e.planName].bpidLinks,
          connectionAddress: e.address.description,
        });
      }
    });

    setCart(newCart);
  };

  const handleDeleteConnection = async (connectionId) => {
    // console.log("deleting connection data: ", connectionId);

    let url =
      "https://b3bq9zjyp4.execute-api.ap-southeast-2.amazonaws.com/api/connection/";
    // let url = "http://localhost:8000/connection/";

    await axios.delete(url + connectionId).then((response) => {
      // console.log(response);
    });
    if (connections.length === 0) {
      setActiveStep(1);
    }
  };

  React.useEffect(() => {
    login();
  }, [login]);

  React.useEffect(() => {
    if (!payment.useSamePaymentMethod) {
      if (connections.length > payment.paymentDetails.length) {
        var newPayment = { ...payment };

        for (let i = 0; i < newPayment.paymentDetails.length; i++) {
          newPayment.paymentDetails[i].address = connections[i].address;
          newPayment.paymentDetails[i].address = connections[i].planName;
        }

        for (
          let i = 0;
          i < connections.length - payment.paymentDetails.length;
          i++
        ) {
          newPayment.paymentDetails.push({
            bsb: "",
            accountNumber: "",
          });
        }

        setPayment(newPayment);
      }
    } else {
      if (payment.paymentDetails[0] === undefined) {
        setPayment({
          paymentDetails: [
            {
              bsb: "",
              accountNumber: "",
            },
          ],
          useSamePaymentMethod: true,
        });
      }
    }
  }, [payment, connections, cart]);

  function pageSwitch(activeStep) {
    switch (activeStep) {
      case 0:
        return (
          <Account
            personalState={{
              user,
              setUser,
            }}
            cafState={{ cafState, setCafState }}
            activeStepState={{ activeStep, setActiveStep }}
          />
        );
      case 1:
        return (
          <Property
            plans={planConfig}
            handleDeleteConnection={handleDeleteConnection}
            connectionsState={{
              connections,
              setConnections,
              handleUpdateConnections,
            }}
            cart={cart}
            cafState={{ cafState, setCafState }}
            user={user.user}
            mediaQuery={mediaQuery}
          />
        );
      case 2:
        return (
          <Payment
            cart={cart}
            connections={connections}
            paymentState={{
              payment,
              setPayment,
            }}
            personalState={{
              user,
              setUser,
            }}
            cafState={{ cafState, setCafState }}
          />
        );
      case 3:
        return (
          <Review
            signupFinished={{ signupFinished, setSignupFinished }}
            user={user}
            connections={connections}
            payment={payment}
            cafDetails={{ cafState, setCafState }}
            activeStepState={{ activeStep, setActiveStep }}
            termsAndConditionsState={{
              termsAndConditions,
              setTermsAndConditions,
            }}
            cafState={{ cafState, setCafState }}
          />
        );
      case 4:
        return <ThankYou setActiveStep={setActiveStep} user={user} />;
      default:
        return <Error />;
    }
  }

  const getRightPane = (activeStep) => {
    if (mediaQuery || activeStep === 4) {
      return null;
    } else if (activeStep === 0 || cart.length === 0) {
      return (
        <>
          <Grid
            container
            item
            p={2}
            id="cartContainerApp"
            sm={12}
            md={4}
            lg={4}
            xl={6}
            justifyContent="center"
            alignItems="center"
          >
            {activeStep === 0 ? (
              <img
                src={Bolt}
                id="banner-image"
                width="75%"
                height="auto"
                alt=""
              />
            ) : (
              <>
                <Grid container justifyContent={"center"}>
                  <Typography variant="subtitle1" align="center">
                    Looks like you dont have any connections...
                  </Typography>
                  <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
                    Click ADD CONNECTION to get started!
                  </Typography>
                  <img
                    src={BlankCart}
                    width="50%"
                    height="auto"
                    id="banner-image"
                    alt=""
                  />
                </Grid>
              </>
            )}
          </Grid>
        </>
      );
    } else if (activeStep === 3 && signupFinished) {
      return (
        <>
          <Grid>
            <img src={House} alt="" />
          </Grid>
        </>
      );
    } else {
      return (
        <Grid item p={2} id="cartContainerApp" md={5} lg={5} xl={6}>
          <Cart
            plans={planConfig}
            cart={cart}
            setCart={setCart}
            connectionsState={{
              connections,
              setConnections,
              handleUpdateConnections,
            }}
            activeStepState={{ activeStep, setActiveStep }}
            user={user.user}
            handleDeleteConnection={handleDeleteConnection}
          />
        </Grid>
      );
    }
  };

  return (
    <BrowserRouter>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Navbar
          mediaQuery={mediaQuery}
          stepperState={stepperState}
          user={user}
          setUser={setUser}
          setActiveStep={setActiveStep}
        />
        <Container sx={{ mb: "50px", maxWidth: "100vw" }}>
          <Grid container direction="row" justifyContent="space-between">
            <Grid
              item
              sx={{ flexGrow: 1 }}
              id="pageContainerApp"
              sm={12}
              md={activeStep !== 4 ? 7 : 12}
              lg={activeStep !== 4 ? 7 : 12}
              xl={activeStep !== 4 ? 6 : 12}
            >
              {pageSwitch(
                user.user !== null && activeStep === 0 ? 1 : activeStep
              )}
            </Grid>
            {getRightPane(activeStep)}
          </Grid>
        </Container>
        <BottomBar
          mediaQuery={mediaQuery}
          stepperState={stepperState}
          user={user}
          cart={cart}
          connections={connections}
          payment={payment}
          caf={cafState}
          termsAndConditionsState={{
            termsAndConditions,
            setTermsAndConditions,
          }}
        ></BottomBar>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
